import { createSlice } from "@reduxjs/toolkit";

export const notificationUpdateAllSlice = createSlice({
  name: "notificationUpdateAll",
  initialState: {
    getNotificationUpdateAllResult: false,
    getNotificationUpdateAllLoading: false,
    getNotificationUpdateAllError: false,
    addNotificationUpdateAllResult: false,
    addNotificationUpdateAllLoading: false,
    deleteNotificationUpdateAllResult: false,
  },
  reducers: {
    notificationUpdateAllReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_NOTIFICATIONUPDATEALL":
          return {
            ...state,
            getNotificationUpdateAllResult: payload.data,
            getNotificationUpdateAllLoading: payload.loading,
            getNotificationUpdateAllError: payload.error,
          };
        case "ADD_NOTIFICATIONUPDATEALL":
          return {
            ...state,
            addNotificationUpdateAllResult: payload.data,
            addNotificationUpdateAllLoading: payload.loading,
          };
        case "DELETE_NOTIFICATIONUPDATEALL":
          return {
            ...state,
            deleteNotificationUpdateAllResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const {
  notificationUpdateAllReducers,
} = notificationUpdateAllSlice.actions;

export default notificationUpdateAllSlice.reducer;
